import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import config from "../config";
import { errLog, eventLog } from "../utils/function";
import Error from "./Error";

function Otp({ randKey, setUser, ui, userInfo }) {
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(30);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const inputRefs = useRef([]);

  const token = JSON.parse(localStorage.getItem("token"));

  useEffect(() => {
    sendOtp();
  }, []);

  const sendOtp = () => {
    axios
      .post(
        `${config.API_URL}/ms/sendOTP`,
        {
          rand_str: randKey.slice(2),
          camp_id: randKey.slice(0, 2),
          randKey: randKey,
          userid: ui?.userName?.value,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        const data = [
          {
            RAND_KEY: randKey,
            CUST_ID: ui.cust_id,
            CAMP_ID: ui.campName,
            STATUS: "Otp Component Loaded.",
          },
        ];
        eventLog(data);
      })
      .catch((err) => {
        const data = {
          sNo: "9999",
          taskName: `Method-POST; EndPoint- ${config.API_URL}/ms/sendOTP`,
          errMessage: {
            Message: err.message,
          },
          errRemarks: "ERROR OCCURED WHILE LOADING OTP COMPONENT",
        };
        errLog(data);
        setMessage(err.response?.data?.message || "Something went wrong");
        setTimeout(() => {
          setMessage("");
        }, 4000);
      });
  };

  const handleResendOtp = () => {
    setResendDisabled(true);
    setTimer(30);
    sendOtp();

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setResendDisabled(false);
          return 30;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleChange = (index, e) => {
    const value = e.target.value;
    if (/^\d$/.test(value) || value === "") {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < otp.length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

  const submit = (e) => {
    e.preventDefault();
    setSubmitting(true);
    const otpValue = otp.join("");

    if (otpValue.length !== 4) {
      setMessage("Please enter a valid 4-digit OTP");
      setSubmitting(false);
      return;
    }

    axios
      .post(
        `${config.API_URL}/ms/verifyOTP`,
        {
          rand_str: randKey.slice(2),
          otp: otpValue,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => {
        setUser(userInfo);
        localStorage.setItem("user", JSON.stringify(userInfo));
        setSubmitting(false);
      })
      .catch((err) => {
        setMessage(err.response?.data?.message || "Invalid OTP");
        setSubmitting(false);
        setTimeout(() => {
          setMessage("");
        }, 3000);
      });
  };

  return (
    <>
      {error ? (
        <Error msg={error} />
      ) : (
        <div className="main-wrapper">
          <div
            className="page-wrapper full-page"
            style={{
              backgroundImage: ui.style.backgroundImage,
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="page-content d-flex align-items-center justify-content-center">
              <div className="row w-100 mx-0 auth-page">
                <div className="col-md-3 col-xl-3 mx-auto col-lg-3">
                  <div
                    className="card"
                    style={{ backgroundColor: "rgba(69, 0, 87, 0.8)" }}
                  >
                    <div className="row">
                      <div className="col-md-12 pl-md-0">
                        <div className="auth-form-wrapper px-5 py-4">
                          <div
                            className="d-block mb-4 mx-auto d-flex justify-content-center align-items-center"
                            style={{
                              backgroundColor: "white",
                              width: "120px",
                              height: "120px",
                              borderRadius: "50%",
                            }}
                          >
                            <img src={`${ui.vendorLogo}`} width="90px" alt="" />
                          </div>
                          <h5 className="font-weight-normal mb-4 text-white">
                            We have sent an OTP. Please Insert here.
                          </h5>
                          {message && (
                            <p className="alert alert-danger">{message}</p>
                          )}
                          <form className="forms-sample" onSubmit={submit}>
                            <div className="otp-input-container">
                              {otp.map((digit, index) => (
                                <input
                                  key={index}
                                  type="text"
                                  className="otp-input"
                                  value={digit}
                                  maxLength="1"
                                  onChange={(e) => handleChange(index, e)}
                                  onKeyDown={(e) => handleKeyDown(index, e)}
                                  ref={(el) => (inputRefs.current[index] = el)}
                                />
                              ))}
                            </div>
                            <div className="mt-3">
                              <button
                                className="btn btn-primary mr-2 mb-2 mb-md-0 text-white"
                                style={ui.submitBtn.style}
                                title={ui.submitBtn.tooltip}
                                onClick={submit}
                              >
                                {submitting && (
                                  <i className="fa fa-spinner fa-spin"></i>
                                )}{" "}
                                {ui.submitBtn.value}
                              </button>
                            </div>
                            <div className="p-0 m-0">
                              <button
                                type="button"
                                className="btn p-0 mr-2 mb-md-0 text-white"
                                onClick={handleResendOtp}
                                disabled={resendDisabled}
                              >
                                {resendDisabled
                                  ? `Resend OTP in ${timer}s`
                                  : "Resend OTP"}
                              </button>
                            </div>
                            <a
                              href={`tel:${ui.help.tollfree}`}
                              className="d-block mt-3 text"
                              style={ui.help.style}
                              title={ui.help.tooltip}
                            >
                              {ui.help.value}
                            </a>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Otp;
